import LoginPage from "./components/LoginPage";
import { SchoolConfig } from "./types/school";

const isLocalDevelopment =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

const resolvedApiBaseUrl = isLocalDevelopment
  ? import.meta.env.VITE_DEV_API_BASE_URL || "/api-proxy"
  : import.meta.env.VITE_API_BASE_URL || "https://api.edunexi.com";

const resolvedRedirectUrl = isLocalDevelopment
  ? import.meta.env.VITE_DEV_REDIRECT_URL || "http://localhost:5173"
  : import.meta.env.VITE_REDIRECT_URL || "https://app.edunexi.com";

// School configuration - This should be customized for each school
const schoolConfig: SchoolConfig = {
  // Basic Information
  name: import.meta.env.VITE_SCHOOL_NAME || "893",
  shortName: import.meta.env.VITE_SCHOOL_SHORT_NAME || "SMCA",
  tagline: import.meta.env.VITE_SCHOOL_TAGLINE || "Excellence in Education",

  // EduNexi Integration
  tenantId: import.meta.env.VITE_TENANT_ID || "smca",
  domain: import.meta.env.VITE_DOMAIN || "thesmca.com",
  apiBaseUrl: resolvedApiBaseUrl,
  redirectUrl: resolvedRedirectUrl,
  googleClientId:
    import.meta.env.VITE_GOOGLE_CLIENT_ID ||
    "913715593746-qjftienmfakvuq89htss2stpn8ktdu45.apps.googleusercontent.com",

  // Visual Branding
  theme: {
    primaryColor: import.meta.env.VITE_PRIMARY_COLOR || "#2563eb",
    secondaryColor: import.meta.env.VITE_SECONDARY_COLOR || "#1e40af",
    backgroundColor: "#f8fafc",
    textColor: "#1f2937",
  },

  // Images and Assets
  images: {
    logo: "/images/school-logo.png",
    heroImage: "/images/school-building.jpg",
    backgroundImage: "/images/school-campus.jpg",
  },

  // Contact Information
  contact: {
    address: import.meta.env.VITE_SCHOOL_ADDRESS || "Your School Address",
    phone: import.meta.env.VITE_SCHOOL_PHONE || "(555) 123-4567",
    email: import.meta.env.VITE_SCHOOL_EMAIL || "info@thesmca.com",
    website: import.meta.env.VITE_SCHOOL_WEBSITE || "https://thesmca.com",
  },

  // Features and Settings
  features: {
    showWelcomeMessage: import.meta.env.VITE_SHOW_WELCOME_MESSAGE === "true",
    showContactInfo: import.meta.env.VITE_SHOW_CONTACT_INFO === "true",
    showSchoolNews: import.meta.env.VITE_SHOW_SCHOOL_NEWS === "true",
    enableDarkMode: import.meta.env.VITE_ENABLE_DARK_MODE === "true",
  },
};

function App() {
  return (
    <div className="App">
      <LoginPage config={schoolConfig} />
    </div>
  );
}

export default App;
